function getStringDate(currentDate) {
  const year = currentDate.getFullYear();
  const mm = currentDate.getMonth() + 1;
  const dd = currentDate.getDate();
  return [year, (mm > 9 ? "" : "0") + mm, (dd > 9 ? "" : "0") + dd].join("-");
}

function getStringHour(currentDate) {
  const hours = currentDate.getHours();
  const minutes = currentDate.getMinutes();
  const seconds = currentDate.getSeconds();
  return [hours, (minutes > 9 ? "" : "0") + minutes, (seconds > 9 ? "" : "0") + seconds].join(":");
}

function getGMT(date) {
  const now = date.toString();
  const fullGmt = now.substr(now.indexOf("+"), 5);
  return `${fullGmt.substr(0, 3)}:${fullGmt.substr(3, 5)}`;
}

export function getTimestamp() {
  const currentDate = new Date();
  const date = getStringDate(currentDate);
  const hour = getStringHour(currentDate);
  return `${date}T${hour}${getGMT(currentDate)}`;
}

export function unixTimeInMinutes(unixTime) {
  let date = new Date(unixTime * 1000);
  return date.getMinutes();
}

export function getUnixTime(date) {
  return Math.floor(date?.getTime() / 1000);
}

export function getEpgTime(hour) {
  let myDate = new Date();
  myDate.setHours(myDate.getHours() + hour);
  myDate.setMinutes(0);
  myDate.setSeconds(0);
  return myDate;
}

export function getHoursFromUnix(unix) {
  const date = new Date(unix * 1000);
  return date.getHours();
}

export function getMinutesFromUnix(unix) {
  const date = new Date(unix * 1000);
  return date.getMinutes();
}

export function timeToMilliseconds(timeString) {
  //timeString  hh:mm:ss format  00:05:00
  const [hours, minutes, seconds] = timeString.split(":").map(Number);
  if (isNaN(hours) || isNaN(minutes) || isNaN(seconds)) {
    return 0;
  }
  const totalMilliseconds = (hours * 3600 + minutes * 60 + seconds) * 1000;
  return totalMilliseconds;
}
